export const regex = {
    emailRegEx: /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/,
};